//  中文
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const zh = {
  // ============= 登录 start ============
  "验证码": "验证码",
  "登录": "登录",
  "请输入验证码": "请输入验证码",
  "验证码不正确!": "验证码不正确!",
  "请输入账号": "请输入账号",
  "请输入密码": "请输入密码",
  "访问地址有误，请在shop后台核实": "访问地址有误，请在shop后台核实",
  // ============= 登录 end ============

  // ============= Layout start ============
  "全屏模式": "全屏模式",
  "首页": "首页",
  "此操作将退出登录, 是否继续?": "此操作将退出登录, 是否继续?",
  "已取消退出": "已取消退出",
  "您有一个新订单": "您有一个新订单",
  "无法获取当前门店信息，请重新登录": "无法获取当前门店信息，请重新登录",
  "收银台": "收银台",
  "收银": "收银",
  "桌台": "桌台",
  "订单": "订单",
  // ============= Layout end  ============

  // ============= 首页 start ============
  "查询会员": "查询会员",
  "商品改价": "商品改价",
  "商品删行": "商品删行",
  "整单取消": "整单取消",
  "挂单": "挂单",
  "折扣": "折扣",
  "抹零": "抹零",
  "请输入内容": "请输入内容",
  "收银员": "收银员",
  "店内就餐": "店内就餐",
  "打包带走": "打包带走",
  "商品名称": "商品名称",
  "商品价格": "商品价格",
  "商品数量": "商品数量",
  "应收": "应收",
  "包装费": "包装费",
  "优惠": "优惠",
  "数量": "数量",
  "件": "件",
  "实收": "实收",
  "收款": "收款",
  "请选择商品": "请选择商品",
  "确定要删除": "确定要删除",
  "提示": "提示",
  "确定": "确定",
  "取消": "取消",
  "请先将购物车内的商品挂单或结账后再取单": "请先将购物车内的商品挂单或结账后再取单",
  "确定要整单取消吗?": "确定要整单取消吗?",
  "请输入会员手机号查询会员，输入完毕后点击确认": "请输入会员手机号查询会员，输入完毕后点击确认",
  "请输入会员手机号": "请输入会员手机号",
  "会员昵称": "会员昵称",
  "余额总计": "余额总计",
  "退出": "退出",
  "该用户不存在": "该用户不存在",
  "折扣抹零": "折扣抹零",
  "当前价格": "当前价格",
  "改价": "改价",
  "实付价格": "实付价格",
  "请输入实付价格": "请输入实付价格",
  "优惠折扣": "优惠折扣",
  "请输入优惠折扣": "请输入优惠折扣",
  "抹分": "抹分",
  "抹角": "抹角",
  "四舍五入到角": "四舍五入到角",
  "四舍五入到元": "四舍五入到元",
  "确 定": "确 定",
  "价格不能为空": "价格不能为空",
  "折扣不能为空": "折扣不能为空",
  "修改价格": "修改价格",
  "本次售价": "本次售价",
  "请输入本次售价": "请输入本次售价",
  "清空": "清空",
  "确认": "确认",
  "商品详情": "商品详情",
  "单位": "单位",
  "规格": "规格",
  "加料": "加料",
  "取 消": "取 消",
  "现金收款": "现金收款",
  "余额收款": "余额收款",
  "其他方式": "其他方式",
  "应收金额": "应收金额",
  "用户通过店内扫码等方式进行支付，确认用户支付成功后，点击确认付款即可完成付款操作。": "用户通过店内扫码等方式进行支付，确认用户支付成功后，点击确认付款即可完成付款操作。",
  "微信支付": "微信支付",
  "支付宝支付": "支付宝支付",
  "pos刷卡": "pos刷卡",
  "请输入会员ID号查询会员，输入完毕后点击确认": "请输入会员ID号查询会员，输入完毕后点击确认",
  "请输入会员ID": "请输入会员ID",
  "登录会员仅作为积分累计，无法享受其他优惠。": "登录会员仅作为积分累计，无法享受其他优惠。",
  "取消收款": "取消收款",
  "订单总价": "订单总价",
  "挂单时间": "挂单时间",
  "删除": "删除",
  "取单": "取单",
  "多语言小票打印": "多语言小票打印",
  "打印语言": "打印语言",
  "中文": "中文",
  "英语": "英语",
  "德语": "德语",
  "法语": "法语",
  "西班牙语": "西班牙语",
  "意大利语": "意大利语",
  "克罗地亚": "克罗地亚",
  "斯洛文尼亚": "斯洛文尼亚",
  "匈牙利语": "匈牙利语",
  "塞尔维亚语": "塞尔维亚语",
  // ============= 首页 end   ============

  // ============= 桌台 start ============
  "未开台": "未开台",
  "已开台": "已开台",
  "就餐中": "就餐中",
  "刷新": "刷新",
  "整单清空": "整单清空",
  "转台": "转台",
  "打印预结单": "打印预结单",
  "催菜": "催菜",
  "人数": "人数",
  "订单来源": "订单来源",
  "请点击左侧桌号台": "请点击左侧桌号台",
  "点选已开台桌台，可以在此查看点餐信息。": "点选已开台桌台，可以在此查看点餐信息。",
  "服务费": "服务费",
  "税费": "税费",
  "协助点餐": "协助点餐",
  "协助加餐": "协助加餐",
  "结账": "结账",
  "完成": "完成",
  "价格": "价格",
  "请选择": "请选择",
  "确定要打印小票吗?": "确定要打印小票吗?",
  "确定要关闭桌台并取消订单吗?": "确定要关闭桌台并取消订单吗?",
  "请选择桌号": "请选择桌号",
  "就餐人数": "就餐人数",
  "下单": "下单",
  "返回": "返回",
  "确定要商品删行吗?": "确定要商品删行吗?",
  "请选择就餐人数": "请选择就餐人数",
  // ============= 桌台 emd ============

  // ============= 订单 start ============
  "下单时间": "下单时间",
  "起始时间": "起始时间",
  "店内订单": "店内订单",
  "自提订单": "自提订单",
  "外卖订单": "外卖订单",
  "名称": "名称",
  "支付时间": "支付时间",
  "消费方式": "消费方式",
  "状态": "状态",
  "单价": "单价",
  "金额": "金额",
  "税率": "税率",
  "税费金额": "税费金额",
  "邮箱地址": "邮箱地址",
  "今天": "今天",
  "昨天": "昨天",
  "一周": "一周",
  "搜索": "搜索",
  "待完成": "待完成",
  "已完成": "已完成",
  "已取消": "已取消",
  "全部": "全部",
  "顾客信息": "顾客信息",
  "用户昵称": "用户昵称",
  "手机号": "手机号",
  "收货地址": "收货地址",
  "取单号": "取单号",
  "就餐方式": "就餐方式",
  "订单号": "订单号",
  "订单金额": "订单金额",
  "订单优惠": "订单优惠",
  "实付金额": "实付金额",
  "支付方式": "支付方式",
  "备注信息": "备注信息",
  "期望配送时间": "期望配送时间",
  "取餐时间": "取餐时间",
  "配送费": "配送费",
  "退款金额": "退款金额",
  "准备中": "准备中",
  "出餐中": "出餐中",
  "待取餐": "待取餐",
  "订单信息": "订单信息",
  "税费详情": "税费详情",
  "取消订单": "取消订单",
  "打印小票": "打印小票",
  "出餐": "出餐",
  "确认送达": "确认送达",
  "退款": "退款",
  "已退款": "已退款",
  "请输入订单号": "请输入订单号",
  "至": "至",
  "开始日期": "开始日期",
  "结束日期": "结束日期",
  "发送账单": "发送账单",
  "请输入邮箱地址": "请输入邮箱地址",
  "确定要催菜吗?": "确定要催菜吗?",
  "确定要完成订单吗?": "确定要完成订单吗?",
  "确定要出餐吗?": "确定要出餐吗?",
  "确定要发送账单吗?": "确定要发送账单吗?",
  "邮箱不能为空": "邮箱不能为空",
  "确定要取消订单吗?": "确定要取消订单吗?",
  "是否确认此操作?": "是否确认此操作?",
  "上传文件只能是excel格式!": "上传文件只能是excel格式!",
  "上传文件大小不能超过 10MB!": "上传文件大小不能超过 10MB!",
  "正在处理,请等待": "正在处理,请等待",
  "本次处理失败": "本次处理失败",
  "总金额": "总金额",
  "可退款金额": "可退款金额",
  "请输入退款金额": "请输入退款金额",
  "超出可退款金额": "超出可退款金额",
  "404错误页面": "404错误页面",
  "合计": "合计",
  "份": "份",
  "余额支付": "余额支付",
  "线下支付(现金支付)": "线下支付(现金支付)",
  "线下支付(自有微信支付)":"线下支付(自有微信支付)",
  "线下支付(自有支付宝支付)":"线下支付(自有支付宝支付)",
  "线下支付(POS刷卡支付)":"线下支付(POS刷卡支付)",
  "进行中":"进行中",
  "待付款":"待付款",
  "待配送":"待配送",
  "配送中":"配送中",
  "待接单":"待接单",
  "待取货":"待取货",
  "已配送":"已配送",
  "已收货":"已收货",
  "待收货":"待收货",
  "待取消":"待取消",
  "会员":"会员",
  "商家":"商家",
  "供应商":"供应商",
  "分销":"分销",
  "通知":"通知",
  "已付款":"已付款",
  "用户下单":"用户下单",
  "收银台下单":"收银台下单",
  "扫码下单":"扫码下单",
  "团购下单":"团购下单",
  "商城订单":"商城订单",
  "积分商城订单":"积分商城订单",
  "余额充值订单":"余额充值订单",
  "购卡订单":"购卡订单",
  "券包订单":"券包订单",
  "配送员押金订单":"配送员押金订单",
  "团购订单":"团购订单",
  "下单减库存":"下单减库存",
  "付款减库存":"付款减库存",
  "商家配送":"商家配送",
  "外卖配送":"外卖配送",
  "到店自提":"到店自提",
  "快递配送":"快递配送",
  "个人中心":"个人中心",
  // ============= 订单 end ============
  ...zhLocale
}


export default zh



// WEBPACK FOOTER //
// ./src/i18n/langs/zh.js